import {Component, Input} from '@angular/core';
import {CalendarEvent} from "../../ParseClass/calendar-event";
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {MatChip, MatChipSet} from "@angular/material/chips";
import {PipesModule} from "../../providers/pipes/pipes.module";
import {AsyncPipe} from "@angular/common";
import {MatDivider} from "@angular/material/divider";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-box-calendar',
    imports: [
        MatCard,
        MatCardTitle,
        MatCardSubtitle,
        MatCardContent,
        MatCardHeader,
        MatChipSet,
        MatChip,
        PipesModule,
        AsyncPipe,
        MatDivider,
        TranslateModule
    ],
    templateUrl: './box-calendar.component.html',
    styleUrl: './box-calendar.component.scss'
})
export class BoxCalendarComponent {
    @Input() calendar?: CalendarEvent
}
